import type {
  LayoutRouteProps,
  PathRouteProps,
  RouteObject,
  RouteProps,
} from 'react-router'
import { lazy, type ReactNode } from 'react'

export const ROUTE_PATHS = {
  default: '/',
  // [plop] Add path route
  quote: 'quote',
  login: 'login',
  auth: '/auth',
  notFound: '/404',
}

export default [
  route(ROUTE_PATHS.login, () => import('./pages/(auth)/login/page')),
  layout(
    () => import('./pages/(auth)/protected-route'),
    [
      layout(
        () => import('./modules/url-parameters/layout'),
        [
          layout(
            () => import('./layouts/header'),
            [
              route(ROUTE_PATHS.default, () => import('./pages/main/page'), [
                // The quote form is the sidebar's default view. Without an index
                // route the sidebar's <Outlet/> came out EMPTY when entering '/' (the
                // form only existed at '/quote' and the navbar points at '/'). '/quote'
                // is kept as an alias for deep links.
                index(() => import('./pages/quote/page')),
                route(ROUTE_PATHS.quote, () => import('./pages/quote/page')),
              ]),
            ],
          ),
        ],
      ),
    ],
    // [plop] Add route
  ),
  // Need to be last
  layout(
    () => import('./layouts/header'),
    [
      route(ROUTE_PATHS.notFound, () => import('./pages/not-found/page')),
      route('*', () => import('./pages/not-found/page')),
    ],
  ),
] as RouteObject[]

function route(
  path: string,
  file: Parameters<typeof lazy>[0],
  children?: RouteProps[],
  props?: PathRouteProps,
): PathRouteProps {
  return {
    path,
    ...layout(file, children, props),
  }
}

function layout(
  file: Parameters<typeof lazy>[0],
  children?: RouteProps[],
  props?: LayoutRouteProps,
): LayoutRouteProps {
  return {
    Component: lazy(file),
    children: children as ReactNode,
    ...props,
  }
}

function index(file: Parameters<typeof lazy>[0]): RouteProps {
  return { index: true, Component: lazy(file) }
}
